import React from 'react';
import { Spin } from 'antd';
import Rectangle from 'react-rectangle';
import VideoPlayerComponent from '../../../../shared/components/VideoPlayerComponent'
import SpecificationAlert from '../../../../shared/components/SpecificationAlert';

/**
 * Renders the visual preview of the content (image/video/loading) within the screen slot.
 * Extracted from RelationSliderComponent (getImage function).
 */
const RelationMediaPreview = ({ relation, display, programmatic }) => {
  if (!relation.content) return null;

  const isExactSize =
    relation.content.width === display.resolution_width &&
    relation.content.height === display.resolution_height;
  const isPendingContent = relation.isPendingContent;
  const isInactive = relation.active === 0;

  return (
    <div className="screenContainer">
      <Rectangle aspectRatio={[display.resolution_width, display.resolution_height]}>
        {/* Image */}
        {relation.content.type === 'image' && (
          <div
            className="screen"
            style={{ filter: isPendingContent || isInactive ? 'brightness(0.5)' : 'none' }}
          >
            <img
              src={
                relation.content && relation.content.ready
                  ? relation.content.file_thumb.replace('.mp4', '-00001.jpg')
                  : null
              }
              className={
                isExactSize || relation.fill_screen ? 'screenPreviewFilled' : 'screenPreview'
              }
              alt=""
            />
          </div>
        )}

        {/* Video */}
        {relation.content && relation.content.ready && relation.content.type === 'video' && (
          <VideoPlayerComponent
            relation={relation}
            forceFill={isExactSize || relation.fill_screen}
          />
        )}

        {/* Loading */}
        {relation.content && relation.content.id && !relation.content.ready && (
          <div className="pulseLoaderContainer">
            <Spin size="large" spinning />
          </div>
        )}
      </Rectangle>

      <SpecificationAlert
        programmatic={programmatic}
        slotLength={display.slot_length}
        contentLength={relation.content.length}
        contentType={relation.content.type}
        pricePerDay={display.price_per_day}
        formatSettings={display.format_settings}
      />
    </div>
  );
};

export default RelationMediaPreview;
